import { useEffect } from 'react';

import { ANALYTICS_EVENTS, ANALYTICS_VIEWS } from 'dpl/constants/analytics';
import { setAnalyticsOrigin } from 'dpl/shared/utils/setAnalyticsOrigin';
import { sendRudderstackEvent } from 'dpl/util/analytics';

const SELECTORS = {
  ANALYTICS_TARGETS: '[data-analytics="true"]',
  BUTTON_CTA_LABEL: '[data-button-cta="true"]'
};

export default function PageAnalytics() {
  function getAnalyticsElements() {
    return [...document.querySelectorAll(SELECTORS.ANALYTICS_TARGETS)];
  }

  useEffect(() => {
    setAnalyticsOrigin({ originView: ANALYTICS_VIEWS.PET_INSURANCE_PAGE });

    function handleClick({ currentTarget }) {
      const { viewFeature, viewFeatureLocation } = currentTarget.dataset;

      const ctaLabelElement =
        currentTarget.querySelector(SELECTORS.BUTTON_CTA_LABEL) ??
        currentTarget;

      sendRudderstackEvent(ANALYTICS_EVENTS.BUTTON_CLICKED, {
        button_cta: ctaLabelElement.textContent.trim(),
        view: ANALYTICS_VIEWS.PET_INSURANCE_PAGE,
        view_feature: viewFeature,
        view_feature_location: viewFeatureLocation
      });
    }

    function addAnalyticsEventHandlers() {
      getAnalyticsElements().forEach(element => {
        element.addEventListener('click', handleClick);
      });
    }

    function removeAnalyticsEventHandlers() {
      getAnalyticsElements().forEach(element => {
        element.removeEventListener('click', handleClick);
      });
    }

    document.addEventListener('DOMContentLoaded', addAnalyticsEventHandlers);

    return removeAnalyticsEventHandlers;
  }, []);

  return null;
}
